<template>
  <div>
    <header class="form-title">
      <Row>
        <Col span="21">
          <Form inline :label-width="100">
            <FormItem label="供应商名字">
              <Input v-model="search.name" />
            </FormItem>
            <FormItem label="手机号">
              <Input v-model="search.phone" />
            </FormItem>
          </Form>

        </Col>
        <Col span="3" align="right">
          <Button type="primary" @click="opensupmodel">
            <Icon type="md-add" />添加供应商
          </Button>
        </Col>
      </Row>
    </header>
    <Table stripe :columns="columns" :data="data" :loading="loadingTable">
      <template slot-scope="{ row, index }" slot="money">
        <span style="color: #ff9800">{{row.beanmoney}}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <ButtonGroup size="small" shape="circle">
          <Button type="primary" @click="edit(row.id)">编辑</Button>
          <Button  @click="toSupplierAnalysis(row.id)">
            <img src="../../assets/img/blue.png" style="width: 20px; display: inline;position: relative;top: 2px;left: -2px">
            <span style="position: relative;top: -3px;left: -2px">分析</span>
          </Button>
          <Button type="error" @click="deletes(row.id)">删除</Button>
        </ButtonGroup>
      </template>
    </Table>
    <div class="pageTotal">
      <Page :total="page.total" show-total :page-size="page.rows" @on-change="onChange" />
    </div>

    <!--dialg-->
    <Modal v-model="supmodel" title="供应商">
      <div>
        <Form inline :label-width="80">
          <FormItem label="名称">
            <Input v-model.trim="formSelect.name" placeholder="请输入供应商名称 (必填)" style="width: 360px" />
          </FormItem>
          <FormItem label="电话">
            <Input v-model.trim="formSelect.phone" placeholder="请输电话 (必填)" style="width: 360px" />
          </FormItem>
          <FormItem label="负责人">
            <Input
              v-model.trim="formSelect.username"
              placeholder="请输入负责人姓名 (必填)"
              style="width: 360px"
            />
          </FormItem>
          <FormItem label="地址">
            <Input v-model.trim="formSelect.address" placeholder="地址" style="width: 360px" />
          </FormItem>

          <FormItem label="开户银行">
            <Input v-model.trim="formSelect.bank" placeholder="开户银行" style="width: 360px" />
          </FormItem>
          <FormItem label="银行账号">
            <Input
              v-model.trim="formSelect.bankcode"
              type="number"
              placeholder="银行账号"
              style="width: 360px"
            />
          </FormItem>
          <FormItem label="欠供应商货款" :label-width="100">
            <router-link :to="'/supplierBill?supId=' + supid" >
              <strong style="color: #ffa800">￥{{formSelect.money}} ></strong>
            </router-link>
          </FormItem>
          <br>
          <FormItem label="是否启用">
            <i-switch size="large" v-model="formSelect.isdel">
              <span slot="open">On</span>
              <span slot="close">Off</span>
            </i-switch>
          </FormItem>
          <FormItem label="备注">
            <Input
              type="textarea"
              :maxlength="50"
              v-model="formSelect.remark"
              placeholder="最多输入50个字符"
              style="width: 360px"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="addSetpoints()">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: {
        sup: "",
        name: "",
        phone:''
      },
      loadingTable: false,
      supmodel: false,
      data: [],
      columns: [
        { title: "供应商", key: "name", align: "center" },
        { title: "负责人", key: "username", align: "center" },
        { title: "联系电话", key: "phone", align: "center" },
        { title: "地址", key: "address", align: "center" },
        { title: "开户银行", key: "bank", align: "center" },
        { title: "银行账号", key: "bankcode", align: "center" },
        {
          title: "欠款供应商",
          key: "beanmoney",
          align: "center",
          slot: "money"
        },
        {
          title: "操作",
          key: "edit",
          align: "center",
          slot: "action",
          width: "200"
        }
      ],
      page: {
        total: 1,
        page: 1,
        rows: 12
      },
      formSelect: {
        name: "",
        phone: "",
        username: "",
        address: "",
        bank: "",
        bankcode: "",
        remark: "",
        isdel: true
      },
      isadd: 0,
      supid: ""
    };
  },

  created: function() {
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
    this.getSupplierList(this.page.page, this.page.rows); //1启用供应商
  },
  watch: {
    "search.name": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.getSupplierList(this.page.page, this.page.rows); //1启用供应商
      }
    },
    "search.phone": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.getSupplierList(this.page.page, this.page.rows); //1启用供应商
      }
    }
  },
  methods: {
    getSupplierList(page, rows) {
      this.$Api
        .getSupplierList({
          cid: this.cid,
          sid: this.sid,
          page: page,
          rows: rows,
          name: this.search.name,
          phone:this.search.phone,
          isdel: 1
        })
        .then(res => {
          if (res.code == 200) {
            this.data = [];
            this.page.total = res.count;
            res.data.forEach((item, index) => {
              var PurchaseList = {};
              (PurchaseList.id = item.id), (PurchaseList.name = item.name);
              PurchaseList.username = item.username;
              (PurchaseList.phone = item.phone),
                (PurchaseList.address = item.address),
                (PurchaseList.bank = item.bank),
                (PurchaseList.bankcode = item.bankcode),
                (PurchaseList.beanmoney = item.money),
                this.data.push(PurchaseList);
            });
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    deletes(id) {
      this.$Api
        .getPurchaseList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000,
          supplierid: id
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data == "") {
              this.$Api
                .deleteSupplier({
                  id: id
                })
                .then(res => {
                  if (res.code == 200) {
                    this.$Message.success(res.msg);
                    this.getSupplierList(this.page.page, this.page.rows); //1启用供应商
                  } else {
                    this.$Message.warning(res.msg);
                  }
                });
            } else {
              this.$Message.warning("该供应商已使用不能删除");
            }
          } else {
            this.$Message.warning(res.msg);
          }
        });
      return;
    },
    //分页
    onChange(num) {
      this.getSupplierList(num, this.page.rows, this.search.sup);
    },
    addSetpoints() {
      if (this.formSelect.name == "") {
        this.$Message.info("名称不能为空");
        return;
      }
      if (this.formSelect.phone == "") {
        this.$Message.info("电话不能为空");
        return;
      }
      var telTest = /^(13[0-9]|15[0-9]|14[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
      if (!telTest.test(this.formSelect.phone)) {
        this.$Message.info("请输入正确的手机号码");
        return;
      }
      if (this.formSelect.username == "") {
        this.$Message.info("负责人不能为空");
        return;
      }
      var isdel = "";
      if (this.formSelect.isdel) {
        isdel = 1;
      } else {
        isdel = 0;
      }
      if (this.isadd == 0) {
        this.$Api
          .addSupplier({
            cid: this.cid,
            sid: this.sid,
            name: this.formSelect.name,
            username: this.formSelect.username,
            phone: this.formSelect.phone,
            address: this.formSelect.address,
            bank: this.formSelect.bank,
            bankcode: this.formSelect.bankcode,
            remark: this.formSelect.remark,
            isdel: isdel
          })
          .then(res => {
            if (res.code == 200) {
              this.$Message.success("添加成功");
              this.getSupplierList(this.page.page, this.page.rows); //1启用供应商
              this.supmodel = false;
              this.formSelect = {};
              this.formSelect.isdel = true;
            } else {
              this.$Message.warning(res.msg);
            }
          })
          .catch(err => {
            this.$Message.warning(err.msg);
          });
      } else {
        this.$Api
          .updateSupplier({
            id: this.supid,
            cid: this.cid,
            sid: this.sid,
            name: this.formSelect.name,
            username: this.formSelect.username,
            phone: this.formSelect.phone,
            address: this.formSelect.address,
            bank: this.formSelect.bank,
            bankcode: this.formSelect.bankcode,
            remark: this.formSelect.remark,
            isdel: isdel
          })
          .then(res => {
            if (res.code == 200) {
              this.$Message.success("修改成功");
              this.getSupplierList(this.page.page, this.page.rows); //1启用供应商
              this.supmodel = false;
              this.formSelect = {};
              this.formSelect.isdel = true;
            } else {
              this.$Message.warning(res.msg);
            }
          })
          .catch(err => {
            this.$Message.warning(err.msg);
          });
      }
    },
    opensupmodel() {
      var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
      if (PermisCode.includes("49")) {
        this.supmodel = true;
        this.formSelect = {};
        this.formSelect.isdel = true;
        this.isadd = 0;
      } else {
        this.$Message.info("暂无权限");
      }
    },
    edit(id) {
      var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
      if (!PermisCode.includes("50")) {
        this.$Message.info("暂无权限");
        return;
      }
      this.isadd = 1;
      this.supid = id;
      this.$Api
        .getSupplier({
          id: id
        })
        .then(res => {
          if (res.code == 200) {
            this.supmodel = true;
            this.formSelect.name = res.data.name;
            this.formSelect.phone = res.data.phone;
            this.formSelect.username = res.data.username;
            this.formSelect.address = res.data.address;
            this.formSelect.bank = res.data.bank;
            this.formSelect.bankcode = res.data.bankcode;
            this.formSelect.remark = res.data.remark;
            this.formSelect.money = res.data.money;
            if (res.data.isdel == 1) {
              this.formSelect.isdel = true;
            } else {
              this.formSelect.isdel = false;
            }
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    toSupplierAnalysis(id) {
      var shop = JSON.parse(localStorage.getItem("shop")).code;
      var shopArray = shop.split(",");
      var flag=0
      shopArray.forEach(item => {
        if (item == "100051" || item == "100060") { //100051皇冠  100060蓝钻 100059黄钻
          this.$router.push("/supplierAnalysis?supId=" + id);
          flag=1
          return
        }
      });

      if(flag==0){
        setTimeout( ()=>{
          this.$Message.info("亲,你还未购买此服务，暂时不能访问!");
        },500)
      }


    }
  }
};
</script>

<style lang="scss" scoped>
</style>